import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Form } from 'src/app/assabil-kernel/models/entities/control-tables/form';
import { ControlTablesService } from 'src/app/assabil-kernel/services/control-tables-service';
import { FormRequest } from 'src/app/assabil-kernel/models/dtos/control-tables/form-request';
import { FormField } from 'src/app/assabil-kernel/models/entities/control-tables/form-field';


@Component({
    selector: 'form-widget',
    templateUrl: './form-widget.component.html',
    styleUrls: ['./form-widget.component.scss']
})

export class FormWidgetComponent extends BaseWidget {
  
  form            : Form = new Form();

 //---------------------------------------------------------------------------------------
  constructor(
      protected toastr               : ToastrService,
      protected leanUtilsService     : LeanUtilsService,
      protected controlTablesService : ControlTablesService) {
      super(toastr, leanUtilsService);

      this.entityName = "form";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(form: Form) {
      this.form  = { ...form };
      this.form.formFields = [];
      if (form.formFields) {
        for (let field of form.formFields) {
          this.form.formFields.push({ ...field });
        }
      }
    }
//---------------------------------------------------------------------------------------

  
//---------------------------------------------------------------------------------------
  getEntity(){
    return this.form;
  }
//---------------------------------------------------------------------------------------


//----------------------------------------------------------------------
saveRow(): Promise<Form> {
  let request: FormRequest = new FormRequest(this.controlTablesService.getUserInfo());
  request.form = this.form;
  return this.controlTablesService.save(this.entityName, request);
}
//----------------------------------------------------------------------


//----------------------------------------------------------------------
new(){
  let formField : FormField = new FormField();
  formField.fieldType = 'text';
  formField.inserted = true;
  this.form.formFields.push(formField);
  this.form.formFields = [...this.form.formFields];
}
//----------------------------------------------------------------------


}
